import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight, MagnifyingGlass } from "@phosphor-icons/react";
import { remap } from "@/lib/palette";

const TRACK_LABEL = {
  "francophone-general": "Francophone — Général",
  "francophone-technical": "Francophone — Technique & Pro",
  "anglophone-general": "Anglophone — General",
  "anglophone-technical": "Anglophone — Technical & Vocational",
};

export default function Courses() {
  const { user } = useAuth();
  const [exams, setExams] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/exams").then((r) => setExams(r.data));
  }, []);

  const myExam = exams.find((e) => e.id === user?.exam_id);
  const filtered = exams.filter((e) => e.name.toLowerCase().includes(q.toLowerCase()) || e.description.toLowerCase().includes(q.toLowerCase()));

  const groups = {};
  filtered.forEach((e) => {
    const key = `${e.track}-${e.category}`;
    (groups[key] ||= []).push(e);
  });

  const Card = ({ e, highlight }) => (
    <Link to={`/app/cours/${e.id}`} data-testid={`exam-card-${e.id}${highlight ? "-featured" : ""}`}
      className={`group relative overflow-hidden rounded-2xl border bg-white p-5 transition hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(4,42,101,0.1)] ${highlight ? "border-terracotta" : "border-border"}`}>
      <div className="absolute right-0 top-0 h-20 w-20 rounded-bl-[2.5rem] opacity-10" style={{ background: remap(e.color) }} />
      <div className="h-2 w-12 rounded-full" style={{ background: remap(e.color) }} />
      <div className="mt-3 font-display text-lg font-bold">{e.name}</div>
      <div className="text-xs text-muted-foreground">{e.classe}</div>
      <p className="mt-2 text-sm text-ink/60">{e.description}</p>
      <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-terracotta">Ouvrir <ArrowRight className="transition group-hover:translate-x-1" /></div>
    </Link>
  );

  return (
    <div className="space-y-8">
      <div className="animate-fade-up">
        <h1 className="font-display text-3xl font-extrabold sm:text-4xl">Cours & matières</h1>
        <p className="mt-1 text-ink/65">Tous les examens officiels du Cameroun, alignés aux programmes.</p>
      </div>

      {myExam && !q && (
        <div>
          <h2 className="mb-3 text-sm font-bold uppercase tracking-wide text-terracotta">Votre examen</h2>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"><Card e={myExam} highlight /></div>
        </div>
      )}

      <div className="relative max-w-md">
        <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" size={18} />
        <input data-testid="course-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un examen…"
          className="w-full rounded-full border border-border bg-white py-2.5 pl-10 pr-4 text-sm outline-none focus:ring-2 focus:ring-terracotta" />
      </div>

      {Object.entries(groups).map(([key, list]) => (
        <div key={key}>
          <h2 className="mb-3 text-sm font-bold uppercase tracking-wide text-forest">{TRACK_LABEL[key]}</h2>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((e) => <Card key={e.id} e={e} />)}
          </div>
        </div>
      ))}
    </div>
  );
}
